import PropTypes from 'prop-types';

/**
 * Displays confidence count badges for enrichment data.
 * Purple badge for confirmed/high-confidence counts, gray for unreviewed/low-confidence.
 * Badges are clickable when onClick handlers are provided.
 */
const ConfidenceBadge = ({ highCount = 0, lowCount = 0, onHighClick, onLowClick }) => {
  const showHigh = highCount > 0;
  const showLow = lowCount > 0;

  const handleHighClick = (e) => {
    if (onHighClick) {
      e.stopPropagation();
      onHighClick();
    }
  };

  const handleLowClick = (e) => {
    if (onLowClick) {
      e.stopPropagation();
      onLowClick();
    }
  };

  return (
    <>
      <span className="confidence-badge--slot confidence-badge--slot-high">
        {showHigh && (
          <span
            className="confidence-badge--high"
            onClick={handleHighClick}
            role={onHighClick ? 'button' : undefined}
            tabIndex={onHighClick ? 0 : undefined}
            aria-label={`${highCount} high confidence matches`}
            onKeyDown={
              onHighClick
                ? (e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), handleHighClick(e))
                : undefined
            }
          >
            {highCount}
          </span>
        )}
      </span>
      <span className="confidence-badge--slot confidence-badge--slot-low">
        {showLow && (
          <span
            className="confidence-badge--low"
            onClick={handleLowClick}
            role={onLowClick ? 'button' : undefined}
            tabIndex={onLowClick ? 0 : undefined}
            aria-label={`${lowCount} low confidence matches`}
            onKeyDown={
              onLowClick
                ? (e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), handleLowClick(e))
                : undefined
            }
          >
            +{lowCount}
          </span>
        )}
      </span>
    </>
  );
};

ConfidenceBadge.propTypes = {
  highCount: PropTypes.number,
  lowCount: PropTypes.number,
  onHighClick: PropTypes.func,
  onLowClick: PropTypes.func,
};

export default ConfidenceBadge;
